import { render, staticRenderFns } from "./superyachtservices.vue?vue&type=template&id=de6659a4"
import script from "./superyachtservices.vue?vue&type=script&lang=js"
export * from "./superyachtservices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports